module.exports = __webpack_public_path__ + "static/media/BHARATFORG_F1.c91b3f87.txt";